/* @flow */

import { compose } from 'ramda';
import { connect } from 'react-redux';

import VirtualBraindateEarlyReminderDumb from './VirtualBraindateEarlyReminderDumb';
import { dismissNotification } from 'src/shared/app/notification/action/uiNotificationActions';
import { getSelf } from 'src/shared/domain/user/selector/userSelectors';
import { getBraindate } from 'src/shared/domain/braindate/selector/braindateSelectors';
import { getBraindateId } from '@braindate/domain/lib/braindate/util';
import { getNotificationData } from 'src/shared/app/notification/util/notificationUtil';

import type { Notification } from 'src/shared/app/notification/type/notificationTypes';

type Props = {
  notification: Notification<>,
};

const mapStateToProps = (state: Object, { notification }: Props): Object => {
  const braindateId = getBraindateId(
    // $FlowIssue
    getNotificationData(notification),
  );

  const braindate = getBraindate(state, { id: braindateId });

  return {
    braindate,
    user: getSelf(state),
  };
};

const mapDispatchToProps = (dispatch: any): Object => ({ dispatch });

const mergeProps = (
  stateProps: Object,
  { dispatch }: Object,
  { notification }: Props,
): Object => ({
  ...stateProps,
  handleDismiss() {
    dispatch(dismissNotification(notification));
  },
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
)(VirtualBraindateEarlyReminderDumb);
